<script>
export default {
    name: 'IlluEnglish',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-english"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M26.5 16.5H14.56l11.94 8.528V16.5zM37.5 38.972V47.5h11.94L37.5 38.972zM26.5 38.972L14.56 47.5H26.5v-8.528zM55.5 37.5h-7.914l7.914 5.54V37.5zM55.5 20.04l-8.075 6.46H55.5v-6.46zM16.414 37.5H8.5v5.54l7.914-5.54zM49.44 16.5H37.5v8.528L49.44 16.5zM8.5 20.96v5.54h7.914L8.5 20.96z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M36 16v12h20v8H36v12h-8V36H8v-8h20V16h8zM25 37L10.06 48H8l14.94-11H25zm18.926 0L56 45.571V47L42 37h1.926zM8 17l14 10h-1.926L8 18.429V17zm48-1L41.06 27H39l14.94-11H56z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
